import { createClient } from '@supabase/supabase-js';
import { getStoredToken } from './utils/session';
import { validateLoginIdentifier, validatePassword } from './utils/inputValidation';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) console.error('❌ Faltan llaves de Supabase');

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  accessToken: async () => getStoredToken(),
});

export const loginWithCredentials = async (identifier, password) => {
  const safeIdentifier = validateLoginIdentifier(identifier);
  const safePassword = validatePassword(password);

  const { data, error } = await supabase.functions.invoke('auth-login', {
    body: { identifier: safeIdentifier, password: safePassword },
  });

  if (error) {
    const serverMessage = data?.error || error.message;
    if (serverMessage && !serverMessage.includes('non-2xx')) {
      throw new Error(serverMessage);
    }
    throw new Error('Error al conectar con el servidor.');
  }

  if (data?.error) throw new Error(data.error);
  if (!data?.user || !data?.access_token) {
    throw new Error('Respuesta de autenticación inválida.');
  }

  return data;
};
